import { DetailsColumn } from './components/DetailsColumn';
import { Column } from '@simplywallst/ui-core';
import loadable from '@loadable/component';
import ChartWrapper from '@/pages/CompanyReport/components/Overview/components/ChartWrapper';
import EarningsRevenueTable from './components/EarningsRevenueTable';
import { RowWithGutter } from './styled';
import { shallowEqual, useSelector } from 'react-redux';
import { selector } from './selector';
import { useOverviewTranslation } from '@/pages/CompanyReport/components/OverviewSection/hooks/useOverviewTranslation';

const DonutChart = loadable(() => import('@/components/DonutChart'), {
  resolveComponent: (component) => component.DonutChart,
});

export function Ratios() {
  const selectedState = useSelector<
    Parameters<typeof selector>[0],
    ReturnType<typeof selector>
  >(selector, shallowEqual);

  const t = useOverviewTranslation();

  return (
    <RowWithGutter>
      <Column colMd={6} colSm={12}>
        <ChartWrapper
          id="overview-earnings-revenue"
          chart={
            <DonutChart
              baseArc={{
                label: t('fundamentals.revenue.chart.marketCap'),
                formattedValue: selectedState.formattedMarketCap,
                rawValue: selectedState.rawMarketCap,
              }}
              outerArc={{
                label: t('fundamentals.revenue.chart.revenue'),
                formattedValue: selectedState.formattedRevenue,
                rawValue: selectedState.rawRevenue,
              }}
              innerArc={{
                label: t('fundamentals.revenue.chart.earnings'),
                formattedValue: selectedState.formattedEarnings,
                rawValue: selectedState.rawEarnings,
              }}
            />
          }
          table={<EarningsRevenueTable />}
          preRenderHeight={292}
          feedbackLabel={t('fundamentals.revenue.chart.feedback')}
        />
      </Column>
      <Column colMd={6} colSm={12}>
        <DetailsColumn />
      </Column>
    </RowWithGutter>
  );
}
